import _ from 'lodash';

import loadTransactionsMixin from '@/mixins/loadTransactionsMixin';
import filterLoadsMixin from '@/mixins/filterLoads';
import bookedLoadMixin from '@/mixins/bookedLoadMixin';

import { txSettlementStrategy } from '@/types';

export default {
  mixins: [
    bookedLoadMixin,
    loadTransactionsMixin,
    filterLoadsMixin,
  ],
  computed: {
    bills() {
      return _.filter(this.billTransactions, tx => this.filterLoadTransaction(tx));
    },
    invoices() {
      return _.filter(this.invoiceTransactions, tx => this.filterLoadTransaction(tx));
    },
    invoiceCount() {
      return _.get(this.invoices, 'length', '');
    },
    payableCount() {
      return _.get(this.bills, 'length', '');
    },
    deliveredLoadInvoiceCount() {
      const approvable = _.filter(this.invoices, tx => this.isBookedLoadDelivered(tx.load));
      return _.get(approvable, 'length', '');
    },
    readyForExportCount() {
      const approved = _.filter(this.invoices, tx => this.isTransactionApproved(tx.load));
      return _.get(approved, 'length', '');
    },
  },
  methods: {
    companyPluginInvoicing(company) {
      return _.get(company, 'plugins.invoicing', {});
    },
    companyPluginLegacyLoadRequirements(company) {
      return _.get(company, 'plugins.loadBuilder.legacyRequirements', false);
    },
    companySettlementStrategy(company) {
      const defallt = txSettlementStrategy.MANUAL_SETTLEMENT;

      // some conditional on the company to choose the strategy
      const strategy = _.get(company, 'plugins.transactionSettlementStrategy', { strategy: defallt });

      let toolbar;
      switch (strategy.strategy) {
        case (txSettlementStrategy.QB_EXPORT):
          // right now, they both do the same thing
          // fall through to manual.

        // eslint-disable-next-line no-fallthrough
        case (txSettlementStrategy.MANUAL_SETTLEMENT):
          toolbar = this.standardInvoiceBillsSettlementStrategyToolbar(company);
          break;
        case (txSettlementStrategy.APPROVE_EXPORT_LOADS):
          toolbar = this.approveExportSettlementStrategyToolbar(company);
          // strategy.navRoute = 'company.transaction.approve';
          break;

        default: toolbar = { };
      }

      const settlement = { ...strategy,
        transactionsToolbar: toolbar,
      };

      return settlement;
    },

    standardInvoiceBillsSettlementStrategyToolbar(company) {
      return {
        title: `${company.companyName} : Load Transactions`,
        navButtons: [
          {
            routeName: 'company.transactions.invoices',
            iconName: 'attach_money',
            count: this.invoiceCount,
          },
          {
            routeName: 'company.transactions.bills',
            iconName: 'credit_card',
            count: this.payableCount,
          },
        ],
      };
    },
    approveExportSettlementStrategyToolbar(company) {
      return {
        title: `${company.companyName} : Load Approvals`,
        navButtons: [
          {
            routeName: 'company.transactions.approve',
            iconName: 'fact_check',
            count: this.deliveredLoadInvoiceCount,
          },
          {
            routeName: 'company.transactions.export',
            iconName: 'cloud_upload',
            count: this.readyForExportCount,
          },
        ],
      };
    },
  },
};




// WEBPACK FOOTER //
// ./src/mixins/companyPluginsMixin.js